import { type FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer.ts';

export type Mode = 'disabled' | 'statuses' | 'approvals';

export const IN_REVIEW_STATUS_ID = '1';
export const APPROVED_STATUS_ID = '2';
export const CHANGES_REQUESTED_STATUS_ID = '3';

export type StatusAndApprovalsConfigProps = {
	spaceKey: string;
	flags: FlagsStateContainer;
};
